import React from "react";
import "./SimplestVerificationTrading.css";
import BubbleSvgButton from "../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import greenCircle from "../../../assets/images/greenCircle.svg";
import { useNavigate } from "react-router-dom";
const SimplestVerificationTrading = () => {
  const navigate=useNavigate();
  return (
    <div className="simplestVerificationTradingSection text-center">
      <img src={greenCircle} alt="greenCircle" className="greenCircle1" />
      <img src={greenCircle} alt="greenCircle" className="greenCircle2" />
      <img src={greenCircle} alt="greenCircle" className="greenCircle3" />
      <img src={greenCircle} alt="greenCircle" className="greenCircle4" />
      <img src={greenCircle} alt="greenCircle" className="greenCircle5" />
      <h2 className="title">
        Simplest and most transparent performance verification in trading{" "}
      </h2>
      <div onClick={()=>navigate("/login")}>
        <BubbleSvgButton
          text="Start Verifying Your Trades"
          className="publicVerifyTradeBtn"
          type="button"
          variant="black"
          containerStyling={{
            justifyContent: "center",
          }}
          mainDivStyle={{
            width: "auto",
            height: "auto",
          }}
        />
      </div>
    </div>
  );
};

export default SimplestVerificationTrading;
